import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/es";
import { createUseStyles } from "react-jss";
import { COLORS } from "../../constants/styles";
import { Row, Col } from "react-flexbox-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useMediaQueryHooks } from "../../hooks/mediaQuery";
import { UserContext } from "../../contexts/user.context"
import { LoadingContext } from "../../contexts/loading.context";

import { useMediaQuery } from "react-responsive";

import axios from "axios";

const useStyles = createUseStyles({
    modulePanel: {
        backgroundColor: COLORS.white,
        borderRadius: 10,
        padding: "48px 36px 16px 32px",
        position: "relative",
    },
    containerModal: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        height: "80vh",
        overflow: "auto",
    },
    orderName: {
        fontSize: 28,
        color: "#37474F",
    },
    containerText: {
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: " #C8CBCC",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
    },
    styleTextArea: {
        minHeight: "40px",
        height: "40px",
        color: "#6C7980",
        fontSize: 18,
        width: "98%",
        fontWeight: "normal",
        outline: "none",
    },
    admin: {
        fontSize: 14,
        color: "#6C7980",
        fontWeight: 700,
        textAlign: "right",
        marginTop: "1%",
    },

    bodyText: {
        fontSize: 14,
        color: "#37474F",
        fontWeight: "bold",
    },

    boxText: {
        color: "#6C797F",
        fontSize: 18,
        fontWeight: "normal",
        lineHeight: "140%",
        wordBreak: "break-word",
    },
    tableText: {
        color: "#6C797F",
        fontSize: 16,
        fontWeight: "normal",
    },
    shippingContainer: {
        display: "flex",
        marginTop: "1%",
        flexDirection: "column",
        width: "100%",
        borderBottom: "1px solid #C8CBCC",
    },
    shippingRowData: {
        display: "flex",
        justifyContent: "space-between",
        marginLeft: "1%",
        marginRight: "1%",
        marginTop: "1%",
        marginBottom: "1%",
    },
    shippingText: {
        fontWeight: "500",
        style: "normal",
        size: "16px",
        lineHeight: "22px",
    },
    totalText: {
        fontWeight: "700",
        style: "normal",
        size: "16px",
        lineHeight: "22px",
    },
    tableRows: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        color: "#37474F",
        fontSize: "15px",
        borderBottom: "1px solid #C8CBCC",
    },

    tableRow: {
        display: "flex",
        width: "100%",
        marginTop: "1.75%",
        marginBottom: "1.75%",
    },
    closeIcon: {},
    containerMobile: {},
    dataInfo: {
        marginTop: 24,
        color: "#37474F",
    },
    titleInfo: {
        color: "#37474F",
        textTransform: "uppercase",
        fontSize: 14,
        fontWeight: 700,
    },
    subTitleInfo: {
        fontSize: 14,
    },
    productContainer: {
        marginTop: 16,
    },
    spaceLine: {
        margin: "10px 0",
    },
    headerItem: {
        display: "flex",
        fontSize: 14,
        justifyContent: "space-between",
        margin: "0 5px",
    },
    containerBtn: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },

    "@media (max-width: 480px)": {
        modulePanel: {
            padding: "15px 15px 15px 15px",
        },
        orderName: {
            fontSize: 18,
            width: 220,
        },
        closeIcon: {
            position: "absolute",
            top: 37,
            right: 19,
        },
        styleTextArea: {
            width: "90%",
            height: "90px",
        },
    },
});

const handleColorInventary = (_stock_status) => {
    return _stock_status === "instock"
        ? { name: `En existencia`, color: "#27A36E" }
        : _stock_status === "outofstock"
            ? { name: "Bajo inventario", color: "#FF6D00" }
            : { name: "Se puede reservar", color: "#FF6D00" };
};

const OrderViewModal = ({ handleClose, order }) => {
    const isPcWindow = useMediaQueryHooks("(min-width: 767px)");

    const classes = useStyles();

    const [orderProducts, setOrderProducts] = useState([]);
    const [shippingMethod, setShippingMethod] = useState("");
    const [shippingTotal, setShippingTotal] = useState(0);
    const [subTotal, setSubTotal] = useState(0);
    const [user] = useContext(UserContext);

    const isMobile = useMediaQuery({ maxWidth: 480 });
    const isMobileOrTablet = useMediaQuery({ maxWidth: 1024 });

    const addDataToComponent = (data) => {
        const orderItems = [];
        if (Object.keys(data).length > 0) {
            setShippingMethod(data.shippingMethod);
            setShippingTotal(data.shippingTotal);
            setSubTotal(data.subtotal);

            data.itemsData.forEach((item) => {
                let itemInfo = {
                    id: item.product_id,
                    description: item.product_name,
                    quantity: item.quantity,
                    price: item.total,
                    inStock: item.stock_status,
                };
                orderItems.push(itemInfo);
            });
            setOrderProducts(orderItems);
        }
    };

    const orderInfo = (id) => {
        setShowLoading(true);
        return new Promise((resolve) => {
            axios({
                method: "POST",
                url: "https://kakaomarket.cr/wp-json/sellerconsole/v1/getorderinfo",
                data: {
                    orderId: id,
                },
            })
                .then((response) => {
                    let data = JSON.parse(response.data).result;
                    if (response.status === 200) {
                        console.log("data:", data);
                        addDataToComponent(data);
                    }
                })
                .finally(() => {
                    setShowLoading(false);
                });
        });
    };

    const setShowLoading = useContext(LoadingContext)[1];

    useEffect(() => {
        orderInfo(order.id);
    }, []);

    return (
        <div className={`${classes.modulePanel} ${classes.containerModal}`}>
            <Row middle="md" style={{ backgroundColor: "white" }}>
                <Col md={10}>
                    <h2 className={classes.orderName}>
                        ORDEN #{order.id} {moment(order.date).format("D ")} DE{" "}
                        {moment(order.date).format("MMMM").toUpperCase()}{" "}
                        {moment(order.date).format("YYYY")}
                    </h2>
                </Col>
                <Col md={2} className={`${classes.closeIcon}`}>
                    <FontAwesomeIcon
                        role="button"
                        onClick={() => {
                            handleClose();
                        }}
                        style={{ marginLeft: "90%", cursor: "pointer" }}
                        icon={faTimes}
                    />
                </Col>
            </Row>
            {!isMobile && (
                <>
                    <Row
                        middle="md"
                        style={{ marginTop: "20px", backgroundColor: "white" }}
                    >
                        <Col
                            md={12}
                            style={{
                                height: isPcWindow ? "100%" : "",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <h2
                                className={classes.bodyText}
                                style={{ textTransform: "uppercase", marginBottom: "5px" }}
                            >
                                Datos Cliente
                            </h2>
                            <div className={classes.containerText} style={{ height: "100%" }}>
                                <h2 className={classes.boxText}>
                                    <b>{order.customerName}</b>
                                </h2>
                                <h2 className={classes.boxText}>0-0000-0000</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row
                        middle="md"
                        style={{ backgroundColor: "white", marginTop: "12px" }}
                    >
                        <Col
                            md={isMobileOrTablet ? 12 : 9}
                            style={{
                                height: isPcWindow ? "100%" : "",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <h2
                                className={classes.bodyText}
                                style={{ textTransform: "uppercase", marginBottom: "5px" }}
                            >
                                Dirección de Envío
                            </h2>
                            <div className={classes.containerText} style={{ height: "100%" }}>
                                <h2 className={classes.boxText}>{order.city}</h2>
                                <h2 className={classes.boxText}>{order.company}</h2>
                                <h2 className={classes.boxText}>{order.country}</h2>
                                <h2 className={classes.boxText}>
                                    {order.address1} {order.address2}
                                </h2>
                                <h2 className={classes.boxText}>
                                    <b>Dirección de envío:</b> {" " + shippingMethod}
                                </h2>
                            </div>
                        </Col>
                        <Col
                            md={isMobileOrTablet ? 12 : 3}
                            style={{ marginTop: isMobileOrTablet ? "20px" : "0" }}
                        >
                            <Row middle="md" style={{ backgroundColor: "white" }}>
                                <Col md={12}>
                                    <h2
                                        className={classes.bodyText}
                                        style={{
                                            textTransform: "uppercase",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Correo
                                    </h2>
                                    <div className={classes.containerText}>
                                        <h2 className={classes.boxText}>{order.email}</h2>
                                    </div>
                                </Col>
                                <Col
                                    md={12}
                                    style={{ marginTop: isMobileOrTablet ? "20px" : "35px" }}
                                >
                                    <h2
                                        className={classes.bodyText}
                                        style={{
                                            textTransform: "uppercase",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Teléfono
                                    </h2>
                                    <div className={classes.containerText}>
                                        <h2 className={classes.boxText}>{`+506 ${order.phone.substr(
                                            0,
                                            4
                                        )}-${order.phone.substr(4, 8)}`}</h2>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row
                        middle="md"
                        style={{ backgroundColor: "white", marginTop: "2%" }}
                    >
                        <Col md={12}>
                            <div className={classes.tableRows}>
                                <div className="table-container">
                                    <div
                                        className="table-column"
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <div
                                            className="column-name"
                                            style={{
                                                flexBasis: "50%",
                                                maxWidth: "50%",
                                                justifyContent: "left",
                                                marginLeft: "1%",
                                            }}
                                        >
                                            <h3 style={{ fontSize: 14, color: "#37474F" }}>
                                                PRODUCTO
                                            </h3>
                                        </div>
                                        <div className="column-name">
                                            <h3 style={{ fontSize: 14, color: "#37474F" }}>
                                                CANTIDAD
                                            </h3>
                                        </div>
                                        <div className="column-name">
                                            <h3 style={{ fontSize: 14, color: "#37474F" }}>
                                                INVENTARIO
                                            </h3>
                                        </div>
                                        <div
                                            className="column-name"
                                            style={{ justifyContent: "right", marginRight: "1%" }}
                                        >
                                            <h3 style={{ fontSize: 14, color: "#37474F" }}>
                                                PRECIO (₡)
                                            </h3>
                                        </div>
                                    </div>
                                    <div className={classes.tableRows}>
                                        {orderProducts.map((product) => {
                                            return (
                                                <div
                                                    className={classes.tableRow}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        justifyContent: "space-between",
                                                    }}
                                                >
                                                    <div
                                                        className="row-data"
                                                        style={{
                                                            flexBasis: "50%",
                                                            maxWidth: "50%",
                                                            justifyContent: "left",
                                                            marginLeft: "1%",
                                                        }}
                                                    >
                                                        {"#" + product.id + " " + product.description}
                                                    </div>
                                                    <div className="row-data">{product.quantity}</div>
                                                    <div className="row-data">
                                                        <svg
                                                            width="8"
                                                            height="8"
                                                            viewBox="0 0 8 8"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle
                                                                cx="4"
                                                                cy="4"
                                                                r="4"
                                                                fill={
                                                                    handleColorInventary(product.inStock).color
                                                                }
                                                            />
                                                        </svg>
                                                        <span style={{ marginLeft: "8px" }}>
                                                            {handleColorInventary(product.inStock).name}
                                                        </span>
                                                    </div>
                                                    <div
                                                        className="row-data"
                                                        style={{
                                                            justifyContent: "right",
                                                            marginRight: "1%",
                                                        }}
                                                    >
                                                        {product.price}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className={classes.shippingContainer}>
                                <div className={classes.shippingRowData}>
                                    <p className={classes.shippingText}>Subtotal</p>
                                    <p className={classes.shippingText}>{subTotal}</p>
                                </div>
                                <div className={classes.shippingRowData}>
                                    <p className={classes.shippingText}>Envío</p>
                                    <p className={classes.shippingText}>{shippingTotal}</p>
                                </div>
                            </div>
                            <div className={classes.shippingRowData}>
                                <p className={classes.totalText}>TOTAL</p>
                                <p className={classes.totalText}>{order.total}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row
                        middle="md"
                        style={{ backgroundColor: "white", marginTop: "2.5%" }}
                    >
                        <Col md={12}>
                            <h2
                                className={classes.bodyText}
                                style={{ textTransform: "uppercase", marginBottom: "5px" }}
                            >
                                Comentarios
                            </h2>
                            <Comment />
                        </Col>
                    </Row>
                </>
            )}

            {isMobile && (
                <div className={classes.containerMobile}>
                    <div className={classes.dataInfo}>
                        <h2 className={classes.titleInfo}>Datos cliente</h2>
                        <p className={classes.subTitleInfo}>{order.customerName}</p>
                        <p className={classes.subTitleInfo}>0-0000-0000</p>
                        <p className={classes.subTitleInfo}>{order.email}</p>
                        <p className={classes.subTitleInfo}>{`+506 ${order.phone.substr(
                            0,
                            4
                        )}-${order.phone.substr(4, 8)}`}</p>
                    </div>
                    <div className={classes.dataInfo}>
                        <h2 className={classes.titleInfo}>Dirección de envío</h2>
                        <p className={classes.subTitleInfo}>{order.city}</p>
                        <p className={classes.subTitleInfo}>{order.company}</p>
                        <p className={classes.subTitleInfo}>{order.country}</p>
                        <p className={classes.subTitleInfo}>
                            {order.address1} {order.address2}
                        </p>
                    </div>

                    <div className={classes.dataInfo}>
                        <h2 className={classes.titleInfo}>Tipo de Envío</h2>
                        <p className={classes.subTitleInfo}>{shippingMethod}</p>
                    </div>
                    <div className={classes.dataInfo}>
                        <h2 className={classes.titleInfo}>Resumen de la orden</h2>
                        <div className={classes.productContainer}>
                            <div className={`${classes.spaceLine} line`}></div>
                            <div className={classes.headerItem} style={{ fontWeight: 600 }}>
                                <p>Producto</p>
                                <p>Cantidad</p>
                                <p>Precio</p>
                            </div>
                            {orderProducts.map((product) => {
                                return (
                                    <>
                                        <div className={`${classes.spaceLine} line`}></div>
                                        <div className={classes.headerItem}>
                                            <p style={{ width: "95px" }}>
                                                {"#" + product.id + " " + product.description}
                                            </p>
                                            <p>{product.quantity}</p>
                                            <p> {product.price}</p>
                                        </div>

                                        <div
                                            className="row-data"
                                            style={{ marginTop: "5px", justifyContent: "start" }}
                                        >
                                            <svg
                                                width="8"
                                                height="8"
                                                viewBox="0 0 8 8"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <circle
                                                    cx="4"
                                                    cy="4"
                                                    r="4"
                                                    fill={handleColorInventary(product.inStock).color}
                                                />
                                            </svg>
                                            <span style={{ marginLeft: "4px", fontSize: "14px" }}>
                                                {handleColorInventary(product.inStock).name}
                                            </span>
                                        </div>
                                    </>
                                );
                            })}

                            <div className={`${classes.spaceLine} line`}></div>
                            <div className={classes.headerItem}>
                                <p className={classes.shippingText}>Subtotal</p>
                                <p>{subTotal}</p>
                            </div>
                            <div className={`${classes.spaceLine} line`}></div>
                            <div className={classes.headerItem}>
                                <p className={classes.shippingText}>Envío</p>
                                <p>{shippingTotal}</p>
                            </div>
                        </div>
                        <div className={`${classes.spaceLine} line`}></div>
                        <div className={classes.headerItem}>
                            <p className={classes.totalText}>TOTAL</p>
                            <p style={{ fontWeight: 700 }}>{order.total}</p>
                        </div>

                        <div className={classes.dataInfo}>
                            <h2 className={classes.titleInfo}>Comentarios</h2>
                            <Comment />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const Comment = ({ }) => {
    const classes = useStyles();
    return (
        <>
            <textarea
                className={`${classes.containerText} ${classes.styleTextArea}`}
                rows="4"
                readOnly
                value=""
            ></textarea>
            <h2 className={`${classes.admin}`}>ADMIN 55/55/55</h2>
        </>
    );
};

export default OrderViewModal;